module.exports = __webpack_public_path__ + "static/img/Tutorial sin texto Redpie4 (1)-9.0306ab58.jpg";